import { useMemo } from 'react';
import { Button, Row } from '../../../commonComponents';
import { InfoSection } from './components/InfoSection';
import { formatExpectedDays } from './utils/formatters';
import { IEditableFormProps } from './Types';
import { Colors } from '../../../themes/colors';
import { ScheduleForm, SchedulePreview } from './components/ScheduleInfo';

export const ScheduleEditable = ({
  jobPosting,
  editMode,
  hideEditButton,
  disableSave,
  control,
  errors,
  onEditClick,
  onCancelClick,
  onSaveClick,
}: IEditableFormProps) => {
  const { scheduleType, expectedDays } = jobPosting || {};

  const expectedDaysDisplay = useMemo(() => formatExpectedDays(expectedDays || []), [expectedDays]);

  if (editMode) {
    return (
      <InfoSection
        icon="calendar-solid"
        title="Schedule"
        rightAction={
          <Row gap={10}>
            <Button
              text="Cancel"
              onClick={onCancelClick}
              style={{ width: 90, height: 30, backgroundColor: Colors.secondary_500 }}
              textStyle={{ fontSize: 16 }}
            />
            <Button
              disabled={disableSave}
              text="Save"
              onClick={onSaveClick}
              style={{ width: 90, height: 30 }}
              textStyle={{ fontSize: 16 }}
            />
          </Row>
        }
      >
        <ScheduleForm control={control} errors={errors} />
      </InfoSection>
    );
  }

  return (
    <InfoSection
      icon="calendar-solid"
      title="Schedule"
      rightActionIcon="edit-pencil"
      onRightActionPress={hideEditButton ? undefined : onEditClick}
    >
      <SchedulePreview scheduleType={scheduleType || ''} expectedDays={expectedDaysDisplay} />
    </InfoSection>
  );
};
